export default "__VITE_ASSET__BmDfNN3I__"